import React from 'react';

/**
 * FindYourSpace Component
 * Section for helping users find rental properties
 */
export default function FindYourSpace() {
  return;
}